<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 3V3.5C8 3.89782 8.15804 4.27936 8.43934 4.56066C8.72064 4.84196 9.10218 5 9.5 5H14.5C14.8978 5 15.2794 4.84196 15.5607 4.56066C15.842 4.27936 16 3.89782 16 3.5V3H18C18.5304 3 19.0391 3.21071 19.4142 3.58579C19.7893 3.96086 20 4.46957 20 5V21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23H6C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21V5C4 4.46957 4.21071 3.96086 4.58579 3.58579C4.96086 3.21071 5.46957 3 6 3H8Z"
      fill="#3F4254"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 2C11 1.73478 11.1054 1.48043 11.2929 1.29289C11.4804 1.10536 11.7348 1 12 1C12.2652 1 12.5196 1.10536 12.7071 1.29289C12.8946 1.48043 13 1.73478 13 2H14.5C14.6326 2 14.7598 2.05268 14.8536 2.14645C14.9473 2.24021 15 2.36739 15 2.5V3.5C15 3.63261 14.9473 3.75979 14.8536 3.85355C14.7598 3.94732 14.6326 4 14.5 4H9.5C9.36739 4 9.24021 3.94732 9.14645 3.85355C9.05268 3.75979 9 3.63261 9 3.5V2.5C9 2.36739 9.05268 2.24021 9.14645 2.14645C9.24021 2.05268 9.36739 2 9.5 2H11Z"
      fill="#3F4254"
    />
    <path
      opacity="0.3"
      d="M11 10H8C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10Z"
      fill="#3F4254"
    />
    <path
      opacity="0.3"
      d="M15 14H8C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14Z"
      fill="#3F4254"
    />
  </svg>
</template>
